import { render } from "./TopClients.vue?vue&type=template&id=08ac1962&scoped=true"
import script from "./TopClients.vue?vue&type=script&lang=js"
export * from "./TopClients.vue?vue&type=script&lang=js"

import "./TopClients.vue?vue&type=style&index=0&id=08ac1962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ac1962"]])

export default __exports__